var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavoriteBadgeReg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35944 14.6371C8.35944 14.6457 8.35925 14.6285 8.35944 14.6371V14.6371ZM23.7344 14.6371C23.6722 17.743 21.9161 20.6759 18.6564 23.1392C17.1199 24.3003 14.9739 24.3003 13.4375 23.1392C10.1777 20.6759 8.42162 17.743 8.35944 14.6371C8.3715 10.552 13.2844 8.53153 16.0469 11.4754C18.811 8.53026 23.723 10.5543 23.7344 14.6371ZM21.2344 14.5887C21.1019 11.9398 17.3946 11.9708 17.2969 14.6371C17.2969 15.3371 16.7373 15.9044 16.0469 15.9044C15.3565 15.9044 14.7969 15.3371 14.7969 14.6371C14.6991 11.9696 10.9908 11.9414 10.8594 14.5887C10.9241 17.4812 13.1087 19.7295 14.9315 21.107C15.5882 21.6033 16.5055 21.6033 17.1622 21.107C18.9852 19.7295 21.1697 17.4812 21.2344 14.5887ZM23.7344 14.6371C23.7344 14.6457 23.7346 14.6285 23.7344 14.6371V14.6371ZM31.9844 16.2212C31.9701 30.62 14.7222 37.8626 4.67069 27.6913C-1.53561 21.6533 -1.53661 10.7889 4.67094 4.75102C14.7234 -5.42017 31.971 1.82333 31.9844 16.2212ZM29.4844 16.2212C29.4844 8.67435 23.4283 2.53453 15.9844 2.53453C-1.92511 3.28635 -1.91992 29.1588 15.9845 29.9079C23.4283 29.9079 29.4844 23.7681 29.4844 16.2212Z",
    fill: "#58C7CE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteBadgeReg);
export default __webpack_public_path__ + "static/media/favoriteBadgeReg.d4ea170b98d2e4ba72362f4f69c0e49c.svg";
export { ForwardRef as ReactComponent };